import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    add: 'Add a beneficial owner',
    completedCount: '{completed}/{total}',
    missing: 'Beneficiaries missing?',
    sections: {
      complete: {
        title: 'Information completed',
      },
      inProgress: {
        title: 'In progress',
      },
      invalid: {
        description: `We have contacted the beneficiaries listed below so that they may make changes to their information. This information is required to open your pro Shine account`,
        title: 'Invalid information',
      },
      missingInfo: {
        description:
          'They will be notified by e-mail to provide us an **identity proof**. This document is **mandatory** to open your Shine pro account.',
        title: 'Information to complete',
      },
      notStarted: {
        title: 'Awaiting reply',
      },
    },
  },
  fr: {
    add: 'Ajouter un bénéficiaire effectif',
    completedCount: '{completed}/{total}',
    missing: 'Bénéficiaires manquants ?',
    sections: {
      complete: {
        title: 'Informations complétées',
      },
      inProgress: {
        title: 'Démarche en cours',
      },
      invalid: {
        description: `Nous avons contacté les bénéficiaires listés ci dessous pour qu’ils puissent apporter des modifications à leurs informations. Ces informations sont obligatoires pour ouvrir votre compte pro Shine.`,
        title: 'Informations invalides',
      },
      missingInfo: {
        description:
          'Il·Elle recevra une notification par email pour nous transmettre un **justificatif d’identité**. Ce document est **obligatoire** pour ouvrir votre compte pro Shine.',
        title: 'Informations à compléter',
      },
      notStarted: {
        title: 'En attente de réponse',
      },
    },
  },
} as const);
